// @flow
import React from 'react';
import { Link } from 'react-router-dom';
import { useSelector } from 'react-redux';
import { isPreRelease } from '@finect/front-utils/isPreRelease';
import { FinectLogoPlus } from '@finect/tabular-components/FinectLogoPlus';
import { tabsData as toolsTabs } from '../../../scenes/Plus/MyTools/data';
import { HeroContainer, HeroWrapper, WelcomeText, NavBar, NavItem, Logo } from './partials';

const sections = [
  { id: 'seleccion', tab: 'Mi Selección', metaTitle: 'Mi Selección', to: '/plus/seleccion' },
  { id: 'cartera', tab: 'Mi Cartera', metaTitle: 'Mi Cartera', to: '/plus/micartera' },
  { id: 'comparador', tab: 'Súpercomparador', metaTitle: 'Súpercomparador', to: '/plus/comparador' },
  { id: 'analisis', tab: 'Análisis', metaTitle: 'Análisis', to: '/plus/analisis' },
  ...isPreRelease ? [{ id: 'chatbot', tab: 'ChatBot', metaTitle: 'ChatBot', to: '/plus/chatbot' }] : [],
  { id: 'herramientas', tab: 'Herramientas', metaTitle: 'Herramientas', to: `/plus/herramientas/${toolsTabs[0].id}` }
  // { id: 'preguntas-frecuentes', tab: 'Preguntas frecuentes', metaTitle: 'Preguntas frecuentes', to: '/plus/preguntas-frecuentes' }
  // { id: 'formacion', tab: 'Formación', metaTitle: 'Formación' }
];

type Props = {
  user?: Object,
  activeTab?: string,
  withHello?: boolean,
  limited?: boolean,
  narrow?: boolean,
  sections?: Array<{
    id: string,
    tab: string,
    metaTitle?: string,
    to?: string
  }>
};

export const PlusHero = (props: Props) => {
  const omninavState: 'opened' | 'closed' = useSelector(state => state.omninav.state);
  const linkProps = {
    rel: 'nofollow'
  };

  // coger la primera palabra del nombre del usuario (si tiene menos de 3 palabras)
  // o las dos primeras palabras (si tiene más de 3 palabras)
  const userName = props.user?.name || '';
  const nameParts = userName.split(' ');
  const name = nameParts.length > 3 ? `${nameParts[0]} ${nameParts[1]}` : nameParts[0];

  const currentSections = props.sections || sections;

  const isPlus = props.user?.plus;

  // `data-plus-nav` es una marca para poder MEDIR esta barra desde fuera: la usa
  // useStickyChromeTop para saber dónde termina el cromo pegajoso de arriba y colocar ahí las
  // cabeceras de tabla. No se puede calcular, porque esta barra se mueve con la omninav.
  return (
    <HeroContainer data-plus-nav $withHello={props.withHello} omninavState={omninavState}>
      <HeroWrapper limited={props.limited} narrow={props.narrow}>
        <div>
          {props.withHello && isPlus ? (
            <WelcomeText>
              <strong>Hola,</strong> {name}
            </WelcomeText>
          ) : (
            <div />
          )}

          {!props.limited && (
            <Logo>
              <FinectLogoPlus />
            </Logo>
          )}
        </div>

        {(isPlus || props.limited) && !props.narrow && (
          <NavBar>
            {currentSections.map((section, index) => (
              <NavItem
                key={index}
                $active={props?.activeTab === section.id}
                {...linkProps}
                {...(section.to && { as: Link, to: section.to })}
              >
                {section.tab}
              </NavItem>
            ))}
          </NavBar>
        )}
      </HeroWrapper>
    </HeroContainer>
  );
};
